import { handleError } from "helpers/sentry";
import { AtxHandoffConfig } from "./legacy-config";

/** The two fields the session token response carries for a mapped session. */
export interface AtxSessionTokenFields {
  dsn?: string;
  flow_uuid?: string;
}

/**
 * Whether this session has been mapped to ATX, and with what.
 *
 * The backend tags the session token response with a dsn (AI Proctored
 * sessions only, behind its rollout flag); the flow uuid is tagged
 * independently and may be absent.
 *
 * ATX only *detects* a secure browser — it has no definerestrictions handshake
 * and no software or URL policy inputs — so a TSB session is never handed
 * over, whatever the backend says.
 */
export const atxHandoffFor = (
  session: AtxSessionTokenFields | undefined,
  enforceTSB: boolean | undefined
): AtxHandoffConfig | undefined => {
  if (!session?.dsn) return undefined;

  if (enforceTSB) {
    handleError("[Splash] Ignoring ATX handoff: session enforces the secure browser");
    return undefined;
  }

  return { dsn: session.dsn, flow_uuid: session.flow_uuid };
};
